import { render, staticRenderFns } from "./admin-product-main.vue?vue&type=template&id=39f04cf0&"
import script from "./admin-product-main.vue?vue&type=script&lang=js&"
export * from "./admin-product-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports